
import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  PlusIcon,
  PencilIcon,
  TrashIcon,
  DocumentTextIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline";
import Sidebar from "../components/Sidebar";


export default function Blogs() {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [deleteModal, setDeleteModal] = useState(null); // { id, title }
  const navigate = useNavigate();

  const fetchBlogs = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) return navigate("/login");

      const res = await fetch("http://localhost:8000/api/blogs", {
        headers: { Authorization: `Bearer ${token}` },
      });

      const data = await res.json();
      if (res.ok) {
        setBlogs(data.blogs || data || []);
      } else {
        setError(data.message || "Failed to load blogs");
      }
    } catch (err) {
      setError("Failed To Fetch Data");
    } finally {
      setLoading(false);
    }
  };

  const deleteBlog = async (id) => {
    try {
      const token = localStorage.getItem("token");
      const res = await fetch(`http://localhost:8000/api/blogs/${id}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` },
      });

      if (res.ok) {
        setBlogs(blogs.filter((b) => b._id !== id));
        setDeleteModal(null);
      } else {
        alert("Delete nahi hua");
      }
    } catch (err) {
      alert("Error bhai");
    }
  };

  useEffect(() => {
    fetchBlogs();
  }, []);

  return (
    <Sidebar>
      {/* Header */}
      <div className="topbar">
        <h1 className="page-title">Blogs Management</h1>
        <Link to="/admin/blog/add" className="btn btn-success btn-icon">
          <PlusIcon className="icon-sm" />
          Add New Blog
        </Link>
      </div>

      {/* Main Card */}
      <div className="card">
        {loading && <div className="text-center py-12 text-gray-500">Loading blogs...</div>}

        {error && <div className="text-red-600 text-center py-6">{error}</div>}

        {!loading && !error && blogs.length === 0 && (
          <div className="empty-state text-center py-16">
            <DocumentTextIcon className="w-20 h-20 text-gray-300 mx-auto mb-4" />
            <p className="text-xl font-medium">No blogs found</p>
            <p className="text-gray-500">Create your first blog post!</p>
          </div>
        )}

        {!loading && blogs.length > 0 && (
          <div className="table-wrapper">
            <table className="table">
              <thead>
                <tr>
                  <th>Image</th>
                  <th>Title</th>
                  <th>Date</th>
                  <th className="text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                {blogs.map((blog) => (
                  <tr key={blog._id}>
                    <td>
                      {blog.pictures?.[0] ? (
                        <img
                          src={blog.pictures[0]}
                          alt="thumb"
                          height="50px"
                          width="50px"
                          className="w-16 h-16 object-cover rounded-lg"
                        />
                      ) : (
                        <div className="w-16 h-16 bg-gray-200 rounded-lg flex items-center justify-center">
                          no image
                        </div>
                      )}
                    </td>
                    <td>
                      <div className="flex items-center gap-2 font-medium">
                        {blog.title}
                      </div>
                    </td>
                    <td className="text-gray-600">
                      {new Date(blog.createdAt || blog.date).toLocaleDateString("en-US", {
                        month: "short",
                        day: "numeric",
                        year: "numeric",
                      })}
                    </td>
                   
                    <td className="text-center">
                      <button
                        onClick={() => navigate(`/admin/blog/edit/${blog._id}`)}
                        className="mx-1 text-blue-600 hover:bg-blue-50 p-2 rounded"
                      >
                        <PencilIcon className="w-5 h-5" />
                      </button>
                      <button
                        onClick={() => setDeleteModal({ id: blog._id, title: blog.title })}
                        className="mx-1 text-red-600 hover:bg-red-50 p-2 rounded"
                      >
                        <TrashIcon className="w-5 h-5" />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* Delete Modal - Beautiful & Clean */}
      {deleteModal && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
          onClick={() => setDeleteModal(null)}
        >
          <div
            className="bg-white rounded-2xl shadow-2xl max-w-md w-full mx-4 overflow-hidden"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="bg-red-600 text-white px-6 py-4 flex justify-between items-center">
              <h3 className="text-xl font-bold">Delete Blog</h3>
              <button onClick={() => setDeleteModal(null)}>
                <XMarkIcon className="w-6 h-6" />
              </button>
            </div>
            <div className="p-6 text-center">
              <p className="text-lg mb-2">
                Are you sure you want to delete?
              </p>
              <p className="text-xl font-semibold text-gray-800">
                "{deleteModal.title}"
              </p>
              <p className="text-sm text-red-600 mt-4">
                This action cannot be undone!
              </p>
            </div>
            <div className="bg-gray-50 px-6 py-4 flex justify-end gap-3">
              <button
                onClick={() => setDeleteModal(null)}
                className="px-6 py-2 border border-gray-300 rounded-lg hover:bg-gray-100"
              >
                Cancel
              </button>
              <button
                onClick={() => deleteBlog(deleteModal.id)}
                className="px-6 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700"
              >
                Yes, Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </Sidebar>
  );
}